interface EventParameters {
    [key: string]: string | number | boolean | string[] | undefined;
}

export interface DataLayerEvent {
    event: string;
    [key: string]: string | number | boolean | string[] | undefined;
}

export const trackEvent = (eventName: string, parameters?: EventParameters): void => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', eventName, parameters);
    }
};

export const pushToDataLayer = (eventData: DataLayerEvent): void => {
    if (typeof window !== 'undefined') {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(eventData);
    }
};

